import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

import {PanelNavigationService} from '@commons/services/navigation/panel-navigation.service';
import {MapService} from '@commons/services/map/map/map.service';
import {MapControlService} from '@commons/services/map/control/map-control.serivce';

import {BaseComponent} from "@shared/components/base-component";

import {MapPanelService} from "@map-panel/services/map-panel.service";
import { MapActionType } from '../enum/map.enum';
import { debounceTime, Subscription } from 'rxjs';

/**
 * Komponent bazowy mapy. Wszelka komunikacja i konfiguracja odbywa się z poziomu tego komponentu.
 */
@Component({
  selector: 'tk-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.less'],
  animations: [
    trigger('segmentChange', [
      state('default', style({
        left: '56px',
        right: '0px',
        bottom: '0px'
      })),
      state('onlyMap', style({
        left: '0px',
        right: '0px',
        bottom: '0px'
      })),
      state('left-1', style({
        left: '416px'
      })),
      state('left-2', style({
        left: '778px'
      })),
      state('right-1', style({
        right: '360px'
      })),
      state('right-2', style({
        right: '120px'
      })),
      state('bottom-1', style({
        bottom: '360px'
      })),
      transition('* => *', [
        animate('0.1s')
      ]),
    ])
  ]
})
export class MapComponent extends BaseComponent implements OnDestroy, OnInit {

  @Input() public hasAccessToAreas: boolean;
  @Input() public isAreasPanelActive: boolean;

  @Output() public onClickModule$: EventEmitter<MapActionType> = new EventEmitter();

  isMapPanelVisible = false;
  visibleSegments?: number;
  panelHeight = 0;
  public isVisibleMapLoader: boolean;

  private prevPanelHeight?: number;
  private isResizeTimeout: any;

  get mapContentClasses(): string {
    let result = '';

    switch (this.visibleSegments) {
      case 1:
        result = 'map-padding-left-1';
        break;

      case 2:
        result = 'map-padding-left-2';
        break;

      case 3:
        result = 'map-padding-bottom-1';
        break;
    }

    if (this.isMapPanelVisible) {
      result += ' map-padding-right-2';
    }

    return result;
  }

  constructor(
    private panelNavigationService: PanelNavigationService,
    private mapService: MapService,
    private mapControlService: MapControlService,
    private mapPanelService: MapPanelService,
  ) {
    super();
    this.subToVisibilitySub();
    this.subToMapControlSizeChange();
    this.subToMapPanelVisibilityService();
  }

  ngOnInit(): void {
    this.onChangeLoaderState();
  }

  ngOnDestroy() {
    this.unsubscribeAll();
  }

  onAnimationFinished(event: any) {
    this.mapService.resizeMap();
  }

  private onChangeLoaderState(): void {
    const sub = this.mapService.isVisibleMapLoader$.subscribe((data) => {
      this.isVisibleMapLoader = data;
    });
    this.addToUnsubscribe(sub);
  }

  private subToMapPanelVisibilityService() {
    this.mapPanelService.isMapPanelVisibleSubject.subscribe(isVisible => {
      // this.isMapPanelVisible = isVisible;
      this.mapService.resizeMap();
    });
  }

  private subToVisibilitySub() {
    this.addToUnsubscribe(
      this.panelNavigationService.getVisibilitySubject().subscribe(result => {
      if (result.subsites) {
        // driver-lite
        if (result.subsites.indexOf('driver-lite') !== -1) {
          this.visibleSegments = 1;

          // driver-details
        } else if (result.subsites.indexOf('driver-details') !== -1) {
          this.visibleSegments = 2;

          // vehicle-lite
        } else if (result.subsites.indexOf('vehicle-lite') !== -1) {
          this.visibleSegments = 1;

          // vehicle-details
        } else if (result.subsites.indexOf('vehicle-details') !== -1) {
          this.visibleSegments = 2;

          // vehicle-full
        } else if (result.subsites.indexOf('vehicle-full') !== -1) {
          this.visibleSegments = 3;
          if (this.prevPanelHeight) {
            this.panelHeight = this.prevPanelHeight;
          }
          if (!this.panelHeight) {
            this.panelHeight = 320;
          }

          // vehicle-details-only
        } else if (result.subsites.indexOf('vehicle-details-only') !== -1) {
          this.visibleSegments = 1;

          // event-lite
        } else if (result.subsites.indexOf('event-lite') !== -1) {
          this.visibleSegments = 1;

          // area-lite
        } else if (result.subsites.indexOf('area-lite') !== -1) {
          this.visibleSegments = 1;

        } else {
          this.visibleSegments = 0;
        }
      }

      if (this.visibleSegments !== 3) {
        this.panelHeight = 0;
      }

      this.mapService.resizeMap();
    }));
  }

  private subToMapControlSizeChange() {
    // zmiana wysokosci
    this.addToUnsubscribe(
      this.mapControlService.getResizeSubject().subscribe(result => {
      // tylko dla dolnego
      if (this.visibleSegments === 3) {

        if (this.isResizeTimeout) {
          clearTimeout(this.isResizeTimeout);
        }

        const height = window.innerHeight
          || document.documentElement.clientHeight
          || document.body.clientHeight;

        const eventHeight = result;

        let panelHeight = (height - eventHeight);
        if (panelHeight < 30) {
          panelHeight = 30;
        }

        if (eventHeight <= 0) {
          panelHeight = height;
        }

        this.prevPanelHeight = this.panelHeight;
        this.panelHeight = panelHeight;

        this.isResizeTimeout = setTimeout(() => {
          this.mapService.resizeMap();
        }, 300);
      }
    }));
  }
}
